import { Platform } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { logger } from '../../helpers/logger.helper';

const storageKey = (userId: string) => `wc_post_game_seen_v1_${userId}`;

export async function getSeenPostGameMatchIds(userId: string): Promise<Set<string>> {
  try {
    const raw =
      Platform.OS === 'web' && typeof window !== 'undefined'
        ? localStorage.getItem(storageKey(userId))
        : await AsyncStorage.getItem(storageKey(userId));
    if (!raw) return new Set();
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return new Set();
    return new Set(parsed as string[]);
  } catch (error) {
    if (__DEV__) logger.warn('postGameResultSeen: read failed', { userId, error });
    return new Set();
  }
}

export async function markPostGameMatchesSeen(userId: string, matchIds: string[]): Promise<void> {
  if (matchIds.length === 0) return;
  try {
    const existing = await getSeenPostGameMatchIds(userId);
    for (const id of matchIds) existing.add(id);
    const json = JSON.stringify([...existing]);
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
      localStorage.setItem(storageKey(userId), json);
    } else {
      await AsyncStorage.setItem(storageKey(userId), json);
    }
  } catch (error) {
    if (__DEV__) logger.warn('postGameResultSeen: write failed', { userId, matchIds, error });
  }
}
